import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Overlay = styled.div`
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 1000;
    padding: 1.2rem;
`;

const Dialog = styled.div`
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1072;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    outline: 0;
    opacity: 1;
`;

const Container = styled.div`
    max-width: 680px;
    margin: 1.75rem auto;
    position: relative;
    width: auto;
    pointer-events: none;
`;

const Content = styled.div`
    position: relative;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
    outline: 0;
`;

const Header = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 1rem;
`;

const Close = styled.button`
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    padding: 1rem;
    margin: -1rem -1rem -1rem auto;
    cursor: pointer;
`;

const Title = styled.h2`
    padding: 0rem;
    margin: 0rem;
`;
const Body = styled.div`
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0 2rem 0;
`;

const Footer = styled.div`
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 1rem;
    border-top: 1px solid #e9ecef;
`;

class Modal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: this.props.open
        };

        this.closeModal = this.closeModal.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.state.modalOpen && nextProps.open) {
            this.setState({
                modalOpen: true
            });
        } else if (this.state.modalOpen && !nextProps.open) {
            this.setState({
                modalOpen: false
            });
        }
    }
    closeModal() {
        this.setState({
            modalOpen: false
        },()=>{
            if(this.props.close){
                this.props.close();
            }
        });
    }

    render() {
        if (!this.state.modalOpen) return null;
        return (
            <React.Fragment>
                {(this.props.isOverlay) ? (<Overlay onMouseDown={this.closeModal}></Overlay>) : null}
                <Dialog>
                    <Container>
                        <Content>
                            <RenderHeader title={this.props.title} showClose={this.props.showClose} closeModal={this.closeModal} />
                            <Body>
                                {this.props.children}
                            </Body>
                            {this.props.footer && (
                                <Footer>
                                    {this.props.footer}
                                </Footer>
                            )}
                        </Content>
                    </Container>
                </Dialog>
            </React.Fragment>
        );
    }
}

function RenderHeader(props){
    if(props.title || props.close){
        return(
            <Header>
                {props.title && (
                    <Title className="title">{props.title}</Title>
                )}
                {props.showClose && (
                    <Close onClick={props.closeModal}>
                        <span aria-hidden>&times;</span>
                    </Close>
                )}
            </Header>
        );
    } else {
        return null;
    }
}

Modal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func,
    showClose: PropTypes.bool,
    type: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    footer: PropTypes.any,
    submitOnClick: PropTypes.func,
    isOverlay: PropTypes.bool.isRequired
};

Modal.defaultProps = {
    open: false,
    showClose: true,
    type: "default",
    title: "",
    children: [],
    isOverlay: true
};

export default Modal;
